import React from 'react'
import './Checkout.css'
import {
    TextField, 
  } from "@material-ui/core";
import PageTitle from '../global/PageTitle/PageTitle'
import { Link } from 'react-router-dom'
import Autocompete from "../JobRequisition/Autocompete";
export default function Checkout() {
  return (
    <> 
<PageTitle title="Checkout" />
<div class ="Checkout">
<div className='catalog-header'>
    <div classNam='header-field'>
       <h4> Company</h4>
    <div className='h-f'>  LTFCORP Life Time, Inc </div> 

    </div>
    <div classNam='header-field'>
       <h4>Requester</h4>
    <div className='h-f'> Test Change (9003358)[C] </div> 

    </div>
    <div classNam='header-field'>
       <h4>Currency</h4>
    <div className='h-f'> USD</div> 

    </div>
    </div>
    <h2 className='shipping-address-h2'>Shipping Address</h2>
    <div className="field-container">
          <div className="field-titles">
            Deliver To
          </div>
          <div className="field-ans">
            Corporate Office 
    
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
            Ship-To-Address
          </div>
          <div className="field-ans">
           2902 Corporate Place<br/> chanhassen, MN 55317 <br/> United States of America
           
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
           Request Date<span className="mandatory">*</span>
          </div>
          <div className="field-ans">
          <TextField
              id="date"
              type="date"
              style={{ padding: "15px", color: "black" }}
              defaultValue="YYYY/MM/DD"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
           Request Date<span className="mandatory">*</span>
          </div>
          <div className="field-ans">
          <Autocompete/>
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
         Requisition Type
          </div>
          <div className="field-ans">
          <Autocompete/>
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
         Sourcing Buyer 
          </div>
          <div className="field-ans">
          <Autocompete/>
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
         Submitted by  
          </div>
          <div className="field-ans">
         Test Change(9003358)[C]
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
            Memo to Suppliers
          </div>
          <div className="field-ans">
            <textarea 
             rows={7} cols={70} />
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
          Internal Memo <span className="mandatory">*</span>
          </div>
          <div className="field-ans">
            <textarea 
             rows={7} cols={70} />
          </div>
        </div>
        
     </div>
    <div className='next-bar'>
  
    <button className='next-btn'>Check out</button>
    <button className='back-btn'>Save for Later</button>
    <button className='continue-btn'>Continue Shopping</button>
     </div>
        </>
  )
}
